(() => {
  const initFlippo = (root = document) => {
    const policyTitle = document.querySelector('.shopify-policy__title h1');
    if (policyTitle && policyTitle.dataset.flippoTranslated !== 'true') {
      const policyTitles = {
        'privacy policy': 'Política de privacidad',
        'terms of service': 'Términos y condiciones',
        'terms and conditions': 'Términos y condiciones',
        'refund policy': 'Política de reembolso',
        'return policy': 'Política de devoluciones',
        'shipping policy': 'Política de envíos',
        'contact information': 'Información de contacto',
        'legal notice': 'Aviso legal',
        'subscription policy': 'Política de suscripción'
      };
      const currentTitle = policyTitle.textContent.trim();
      const translatedTitle = policyTitles[currentTitle.toLowerCase()];

      if (translatedTitle) {
        policyTitle.textContent = translatedTitle;
        document.title = document.title.replace(currentTitle, translatedTitle);
      }

      policyTitle.dataset.flippoTranslated = 'true';
    }

    root.querySelectorAll('[data-flippo-menu-button]').forEach((button) => {
      if (button.dataset.flippoBound === 'true') return;
      button.dataset.flippoBound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      button.addEventListener('click', () => {
        const open = menu.classList.toggle('open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.classList.remove('open');
          button.setAttribute('aria-expanded', 'false');
        });
      });
    });

    root.querySelectorAll('.bbtn').forEach((button) => {
      if (button.dataset.flippoBound === 'true') return;
      button.dataset.flippoBound = 'true';
      button.addEventListener('click', () => {
        const panel = button.nextElementSibling;
        if (!panel) return;
        const open = panel.classList.toggle('open');
        button.classList.toggle('open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    root.querySelectorAll('[data-recipe-slideshow]').forEach((slideshow) => {
      if (slideshow.dataset.flippoBound === 'true') return;
      slideshow.dataset.flippoBound = 'true';

      const slides = [...slideshow.querySelectorAll('[data-recipe-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-recipe-dot]')];
      if (slides.length < 2 || dots.length < 2) return;

      const setActive = (index) => {
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => setActive(index));
      });

      setActive(0);
    });

    root.querySelectorAll('[data-ugc-carousel]').forEach((carousel) => {
      if (carousel.dataset.flippoBound === 'true') return;
      carousel.dataset.flippoBound = 'true';
      const track = carousel.querySelector('[data-ugc-track]');
      const prev = carousel.querySelector('[data-ugc-prev]');
      const next = carousel.querySelector('[data-ugc-next]');
      if (!track) return;

      const pauseVideos = () => {
        carousel.querySelectorAll('video').forEach((video) => video.pause());
      };

      const updateArrows = () => {
        if (!prev || !next) return;
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollBySlide = (direction) => {
        const firstItem = track.querySelector('.flippo-ugc__item');
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const amount = firstItem ? firstItem.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: direction * amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        pauseVideos();
      };

      prev?.addEventListener('click', () => scrollBySlide(-1));
      next?.addEventListener('click', () => scrollBySlide(1));
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      carousel.querySelectorAll('video').forEach((video) => {
        const media = video.closest('.flippo-ugc__media');
        const playButton = media?.querySelector('[data-ugc-play]');

        const syncPlayState = () => {
          media?.classList.toggle('is-playing', !video.paused && !video.ended);
        };

        const toggleVideo = () => {
          if (video.paused || video.ended) {
            video.play();
          } else {
            video.pause();
          }
        };

        playButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleVideo();
        });

        video.addEventListener('click', (event) => {
          event.preventDefault();
          toggleVideo();
        });

        video.addEventListener('play', () => {
          carousel.querySelectorAll('video').forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
          syncPlayState();
        });
        video.addEventListener('pause', syncPlayState);
        video.addEventListener('ended', syncPlayState);
        syncPlayState();
      });
    });

    root.querySelectorAll('[data-flab-reports]').forEach((filters) => {
      if (filters.dataset.flippoBound === 'true') return;
      filters.dataset.flippoBound = 'true';

      const wrap = filters.closest('.wrap');
      const reports = wrap?.querySelector('.reports');
      const empty = reports?.querySelector('.reports-empty');
      if (!reports || !empty) return;

      let recipe = 'ternera';
      let category = 'all';
      const emptyMessages = {
        fq: ['Aún no hay informes físico-químicos publicados.', 'Se publican —con sus valores reales— al cerrar la analítica de Anabiol v6.'],
        homo: ['El plan de homogeneidad está en validación interna.', 'Publicaremos los resultados con su trazabilidad completa, no antes.'],
        tox: ['La analítica de toxinas está en curso en Anabiol (ENAC).', 'Se publicará en cuanto el informe esté en mano.'],
        micro: ['No hay informes de microbiología para esta receta.', ''],
        all: ['No hay informes para esta combinación.', '']
      };

      const applyFilters = () => {
        let visible = 0;
        reports.querySelectorAll('.report').forEach((card) => {
          const isVisible = (recipe === 'all' || card.dataset.recipe === recipe) && (category === 'all' || card.dataset.cat === category);
          card.style.display = isVisible ? '' : 'none';
          if (isVisible) visible += 1;
        });
        if (visible === 0) {
          const message = emptyMessages[category] || emptyMessages.all;
          empty.innerHTML = message[0] + (message[1] ? `<span class="mono">${message[1]}</span>` : '');
          empty.classList.add('show');
        } else {
          empty.classList.remove('show');
        }
      };

      filters.querySelectorAll('.fchip[data-recipe]').forEach((button) => {
        button.addEventListener('click', () => {
          filters.querySelectorAll('.fchip[data-recipe]').forEach((item) => item.classList.remove('active'));
          button.classList.add('active');
          recipe = button.dataset.recipe;
          applyFilters();
        });
      });

      filters.querySelectorAll('.fchip[data-cat]').forEach((button) => {
        button.addEventListener('click', () => {
          filters.querySelectorAll('.fchip[data-cat]').forEach((item) => item.classList.remove('active'));
          button.classList.add('active');
          category = button.dataset.cat;
          applyFilters();
        });
      });

      applyFilters();
    });

    root.querySelectorAll('[data-flab-recipes]').forEach((recipes) => {
      if (recipes.dataset.flippoBound === 'true') return;
      recipes.dataset.flippoBound = 'true';

      const dataNode = recipes.querySelector('[data-flab-recipes-json]');
      const ingredients = recipes.querySelector('.rx-ings');
      const profile = recipes.querySelector('.rx-profile');
      const bars = recipes.querySelector('.rx-bars');
      if (!dataNode || !ingredients || !profile || !bars) return;

      let data = {};
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      let current = recipes.querySelector('.rx-tab.active')?.dataset.r || Object.keys(data)[0];
      let activeIngredient = 0;

      const renderRecipe = () => {
        const recipeData = data[current];
        if (!recipeData) return;
        ingredients.innerHTML = '';
        recipeData.ings.forEach((item, index) => {
          const button = document.createElement('div');
          button.className = `rx-ing${index === activeIngredient ? ' active' : ''}`;
          button.innerHTML = `<div class="rn">${item.n}</div><div class="rt">${item.t}</div>`;
          button.addEventListener('click', () => {
            activeIngredient = index;
            renderRecipe();
          });
          ingredients.appendChild(button);
        });

        const item = recipeData.ings[activeIngredient];
        profile.innerHTML = `<div class="rp-t">${item.t}</div><div class="rp-d">${item.d}</div>`;
        bars.innerHTML = '<div class="bl">Perfil estimado · definitivo con Anabiol v6</div>' + recipeData.bars.map((bar) => (
          `<div class="rx-bar"><span class="nm">${bar[0]}</span><span class="bb"><i style="width:${bar[1]}%"></i></span><span class="vv">est.</span></div>`
        )).join('');
      };

      recipes.querySelectorAll('.rx-tab').forEach((tab) => {
        tab.addEventListener('click', () => {
          recipes.querySelectorAll('.rx-tab').forEach((item) => item.classList.remove('active'));
          tab.classList.add('active');
          current = tab.dataset.r;
          activeIngredient = 0;
          renderRecipe();
        });
      });

      renderRecipe();
    });

    root.querySelectorAll('.flippo-lab-page .xcard').forEach((card) => {
      if (card.dataset.flippoBound === 'true') return;
      card.dataset.flippoBound = 'true';
      card.addEventListener('click', () => {
        card.classList.toggle('open');
      });
    });

    const counterNodes = root.matches && root.matches('.flippo-lab-page')
      ? root.querySelectorAll('.counter .num[data-to]')
      : root.querySelectorAll('.flippo-lab-page .counter .num[data-to]');

    counterNodes.forEach((counter) => {
      if (counter.dataset.flippoBound === 'true') return;
      counter.dataset.flippoBound = 'true';
      const target = parseFloat(counter.dataset.to);
      if (Number.isNaN(target)) return;

      const animate = () => {
        if (counter.dataset.done === 'true') return;
        counter.dataset.done = 'true';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          counter.textContent = String(target);
          return;
        }

        counter.textContent = '0';
        let start = null;
        const duration = 1100;

        const step = (timestamp) => {
          if (!start) start = timestamp;
          const progress = Math.min((timestamp - start) / duration, 1);
          counter.textContent = String(Math.round(target * progress));
          if (progress < 1) window.requestAnimationFrame(step);
        };

        window.requestAnimationFrame(step);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animate();
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
        observer.observe(counter);
      } else {
        animate();
      }
    });

    const imageReveals = root.matches && root.matches('[data-image-reveal]')
      ? [root]
      : root.querySelectorAll('[data-image-reveal]');

    imageReveals.forEach((reveal) => {
      if (reveal.dataset.flippoBound === 'true') return;
      reveal.dataset.flippoBound = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let ticking = false;

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

      const updateProgress = () => {
        ticking = false;

        if (!reveal.isConnected || reduceMotion.matches) {
          reveal.style.setProperty('--bowl-reveal-progress', '0');
          return;
        }

        const rect = reveal.getBoundingClientRect();
        const startOffset = window.innerHeight * 0.68;
        const revealDistance = Math.max(window.innerHeight * 1.1, reveal.offsetHeight * 0.9);
        const progress = clamp((startOffset - rect.top) / revealDistance, 0, 1);
        reveal.style.setProperty('--bowl-reveal-progress', progress.toFixed(3));
      };

      const requestTick = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      };

      window.addEventListener('scroll', requestTick, { passive: true });
      window.addEventListener('resize', requestTick);
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', requestTick);
      } else {
        reduceMotion.addListener(requestTick);
      }
      requestTick();
    });

    const revealItems = root.querySelectorAll('.reveal:not(.in)');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealItems.forEach((item) => io.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('in'));
    }
  };

  const updateMobileCta = () => {
    const mcta = document.getElementById('mcta');
    if (!mcta) return;
    const show = window.innerWidth < 880;
    if (show) {
      document.documentElement.style.setProperty('--mcta-current-height', `${mcta.offsetHeight}px`);
    }
    mcta.classList.toggle('show', show);
    document.body?.classList.toggle('mcta-visible', show);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initFlippo(document);
    updateMobileCta();
  });
  document.addEventListener('shopify:section:load', (event) => initFlippo(event.target));
  document.addEventListener('shopify:section:select', (event) => initFlippo(event.target));
  window.addEventListener('scroll', updateMobileCta, { passive: true });
  window.addEventListener('resize', updateMobileCta);
})();
